<template>
  <div class="my-3 py-2 container-fluid">
    <div v-if="userRole === 'Super-Admin' || userRole === 'Admin'">
      <button
        v-if="!isOldCoursesSubcoursesVisible"
        @click="oldCoursesSubcourses"
        class="mb-3 btn btn-sm btn-outline-success"
      >
        {{ $t("seasons.createSeason") }}
      </button>
      <div class="col-12">
        <transition name="slide-fade">
          <season-survey
            v-if="isOldCoursesSubcoursesVisible"
            :courses="courses"
            :lastSeason="lastSeason"
            @season-created="seasonCreated"
          />
        </transition>
      </div>
    </div>
    <div v-if="!isOldCoursesSubcoursesVisible">
      <div class="card-header pb-0">
        <h6>{{ $t("seasons.titles") }}</h6>
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                >
                  {{ $t("seasons.title") }}
                </th>
                <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                >
                  {{ $t("teachers.activ") }}
                </th>
                <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                >
                  {{ $t("global.createdAt") }}
                </th>
                <!-- <th class="text-secondary opacity-7"></th> -->
                <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                >
                  {{ $t("teachers.details") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in seasons" :key="item.id">
                <td>
                  <div class="d-flex px-2 py-1">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-0 text-sm">{{ item.title }}</h6>
                    </div>
                  </div>
                </td>
                <td class="align-middle text-center text-sm">
                  <soft-badge
                    :color="item.valid ? 'success' : 'secondary'"
                    variant="gradient"
                    size="sm"
                  >
                    {{ $t(item.valid ? "global.yes" : "global.no") }}
                  </soft-badge>
                </td>
                <td class="align-middle text-center">
                  <span class="text-secondary text-xs font-weight-bold">{{
                    item.created_at
                  }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span @click="activateSeason(item)">
                    <soft-badge
                      :class="item.valid ? 'disabled' : 'enabled'"
                      :color="!item.valid ? 'success' : 'secondary'"
                      variant="gradient"
                      size="sm"
                    >
                      {{ !item.valid ? $t("global.activate") : "" }}
                    </soft-badge>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert2";
import SoftBadge from "@/components/SoftBadge.vue";
import SeasonSurvey from "./components/SeasonSurvey.vue";

export default {
  name: "seasons",
  components: {
    SoftBadge,
    SeasonSurvey,
  },
  computed: {
    userRole() {
      return localStorage.getItem("userRole");
    },
  },
  data() {
    return {
      seasons: [],
      courses: [],
      isOldCoursesSubcoursesVisible: false,
      season: localStorage.getItem("season"),
    };
  },
  created() {
    this.getSeasons();
  },
  methods: {
    oldCoursesSubcourses() {
      this.isOldCoursesSubcoursesVisible = true;
    },
    async getSeasons() {
      const response = await axios.get("seasons");
      this.seasons = response.data.seasons;
      this.getCourses();
    },
    async newSeason() {
      const result = await swal.fire({
        title: this.$t("global.areYouSure"),
        text: "",
        icon: "question",
        showCancelButton: true,
        cancelButtonText: this.$t("global.no"),
        cancelButtonColor: "#f54539",
        confirmButtonText: this.$t("global.yes"),
        confirmButtonColor: "#82d616",
      });
      if (result.isConfirmed) {
        try {
          swal.fire({
            title: this.$t("global.loading"),
            text: this.$t("global.plsWait"),
            allowOutsideClick: false,
            didOpen: () => {
              swal.showLoading();
            },
          });
          const response = await axios.get("new-season");
          if (response.status == 200) {
            swal.close();
            swal.fire({
              icon: "success",
              showLoaderOnConfirm: true,
              title: this.$t(response.data.message),
              showConfirmButton: true,
            });
          }
        } catch (error) {
          if (
            error.response &&
            (error.response.status === 403 || error.response.status === 400)
          ) {
            swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text:
                this.$t(error.response.data.message) ||
                "You are not authorized to perform this action.",
              icon: "error",
            });
          } else {
            swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text: "Something went wrong. Please try again later.",
              icon: "error",
            });
          }
        }
      } else {
        swal.close();
        swal.fire({
          title: this.$t("global.creatingCancelled"),
          text: "",
          icon: "success",
        });
      }
      this.getSeasons();
    },
    async activateSeason(season) {
      if (!season.valid) {
        const response = await axios.get("selected-season", {
          params: {
            selected_season: season.title,
          },
        });
        this.season = response.data.season;
        this.$store.dispatch("updateSeason", this.season);
        this.getSeasons();
      }
    },
    async getCourses() {
      let response = await axios.get("courses/all");
      this.courses = response.data.courses;
      this.lastSeason = response.data.last_season;
    },
    seasonCreated() {
      this.getSeasons();
      this.isOldCoursesSubcoursesVisible = false;
    },
  },
};
</script>
<style scoped>
.disabled {
  pointer-events: none !important;
}
.enabled {
  cursor: pointer !important;
}
</style>
